module.exports = __webpack_public_path__ + "static/media/drag.1c2570a8.svg";